import { fetchConversations } from '../conversations/fetchConversations'

export const MARK_CURRENT_CONVERSATION_AS_READ_BEGIN = 'MARK_CURRENT_CONVERSATION_AS_READ_BEGIN'
export const MARK_CURRENT_CONVERSATION_AS_READ_SUCCESS = 'MARK_CURRENT_CONVERSATION_AS_READ_SUCCESS'
export const MARK_CURRENT_CONVERSATION_AS_READ_FAILED = 'MARK_CURRENT_CONVERSATION_AS_READ_FAILED'


const markCurrentConversationAsReadBegin =   (payload) => ({ type: MARK_CURRENT_CONVERSATION_AS_READ_BEGIN, payload })
const markCurrentConversationAsReadSuccess = (payload) => ({ type: MARK_CURRENT_CONVERSATION_AS_READ_SUCCESS, payload })
const markCurrentConversationAsReadFailed =  (payload) => ({ type: MARK_CURRENT_CONVERSATION_AS_READ_FAILED, payload })

export const markCurrentConversationAsRead = () => {
  return (dispatch, getState) => {
    const { organization, currentConversation } = getState()
    dispatch(markCurrentConversationAsReadBegin())
    return $.ajax(`/api/staff/v1/conversations/${currentConversation.id}/mark_as_read.json`, {
      method: 'POST'
    }).then((response)=>{
      dispatch(markCurrentConversationAsReadSuccess(response))
    })
  }
}